import React, { forwardRef } from "react";
import classes from "./ExportMenu.module.scss";
import { exportBjyoCsv, exportOrdersToCsv } from "../../../functions/export";
import WithIconButton from "../WithIconButton";
import { CurrencyYen } from "@mui/icons-material";
import { CheckCircleOutline } from "@material-ui/icons";
import { DEDUCTION } from "../../../constants/deduction";
import { ORDER_RECEIVED } from "../../../constants/orderStatus";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
const aggregateDeductionPriceByBillingUserId = (products) => {
  const aggregation = {};

  products
    .filter(
      (product) =>
        product.status === ORDER_RECEIVED && product.billing_user_flg === "有"
    )
    .forEach((product) => {
      const billing_user_id = Number(product.billing_user_id);
      const deduction_price = Number(product.deduction_price);

      if (!aggregation[billing_user_id]) {
        // billing_user_idが初めて出現した場合
        aggregation[billing_user_id] = {
          billing_user_id: billing_user_id,
          billing_user_name: product.billing_user_name,
          deduction_price: deduction_price,
        };
      } else {
        // 既に存在するbilling_user_idの場合、deduction_priceを加算
        aggregation[billing_user_id].deduction_price += deduction_price;
      }
    });

  // 集計結果を配列に変換
  const result = Object.values(aggregation);

  // 社員番号（billing_user_id）の昇順でソート
  result.sort((a, b) => {
    return a.billing_user_id - b.billing_user_id;
  });

  // ソート済みの結果を返す
  return result;
};
// カスタムスタイルの Tooltip を作成
const RedTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: "red",
    color: "white",
    fontSize: 14,
    marginRight: 10,
  },
});
const ExportMenu = forwardRef((props, ref) => {
  const { orders } = props;
  const handleBjyoExport = () => {
    console.log("bjyoData");
    const bjyoData = aggregateDeductionPriceByBillingUserId(orders);
    console.log("bjyoData", bjyoData);
    exportBjyoCsv(bjyoData);
  };
  return (
    <div className={classes.mobileNav} ref={ref}>
      <div>
        <WithIconButton
          label="確認用"
          fontSize={14}
          width={100}
          height={32}
          bottom={0}
          color="blue"
          icon={<CheckCircleOutline />}
          onClick={() => exportOrdersToCsv(orders)} // アイコンをpropsで渡す
        />
      </div>
      <RedTooltip
        title={
          <React.Fragment>
            <div style={{ fontWeight: "bold", marginBottom: 4 }}>
              奉行用のCSVを出力します
            </div>
            <div>表示データの内、検収済かつ社員購入のデータが対象です</div>
          </React.Fragment>
        }
        arrow
      >
        <div>
          <WithIconButton
            label="奉行用"
            fontSize={14}
            width={100}
            height={32}
            bottom={0}
            color="red"
            icon={<CurrencyYen />} // アイコンをpropsで渡す
            onClick={handleBjyoExport}
          />
        </div>
      </RedTooltip>
    </div>
  );
});

export default ExportMenu;
